import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css, CSSProperties, DefaultTheme} from 'styled-components'

export const StyledUserPermissionsFormRow = styled.div<{$isHeader?: boolean}>(
    ({theme, $isHeader}) => css`
        display: grid;
        grid-template-columns: 1fr 100px 100px;
        padding: ${theme.spacing * 1.5}px ${theme.spacing * 4}px;
        ${theme.typography.textMd};
        align-items: center;
        width: 100%;
        ${$isHeader
            ? css`
                  border: 1px solid ${theme.palette.neutral[200]};
                  border-radius: 6px;
                  background-color: ${theme.palette.neutral[50]};
              `
            : css`
                  min-height: 42px;
              `}
    `
)

export const StyledUserPermissionsFormRowData = styled.div(
    ({theme}) => css`
        ${theme.typography.textSm};
    `
)

export const StyledUserPermissionsFormRowHeading = styled.h3<{$align?: CSSProperties['textAlign']}>(
    ({theme, $align}) => css`
        color: ${theme.palette.neutral[600]};
        font-weight: 500;
        text-align: ${$align ?? 'left'};
        ${theme.typography.textSm};
    `
)

export const makePermissionsCheckboxesGridBaseStyle = (theme: DefaultTheme) => css`
    padding: ${theme.spacing * 1.5}px ${theme.spacing * 4}px;
`

export const StyledUserPermissionsCheckboxesGridHeader = styled(Grid)(
    ({theme}) => css`
        ${makePermissionsCheckboxesGridBaseStyle(theme)}
        ${theme.typography.textSm};
        align-items: center;
        border-radius: 6px;
        border: 1px solid ${theme.palette.neutral[100]};
        color: ${theme.palette.neutral[600]};
        background-color: ${theme.palette.neutral[50]};
        height: 32px;
        font-weight: 500;
    `
)

export const StyledUserPermissionsCheckboxesGridBody = styled(Grid)(
    ({theme}) => css`
        ${makePermissionsCheckboxesGridBaseStyle(theme)}
    `
)

export const StyledUserPermissionsCheckboxesGridBodyRow = styled.div`
    display: contents;
`

export const StyledPermissionGridItem = styled(GridItem)(
    ({theme: {typography, spacing}}) => css`
        ${typography.textMd};
        padding: ${spacing * 2}px 0;
        font-weight: 500;
    `
)
